import Vue from 'vue';
import ElementUI from 'element-ui';
const locale = require('element-ui/lib/locale/lang/ru-RU.js').default;

Vue.use(ElementUI, { locale });
